// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorcorrecs > .tox-tinymce {
  height: calc(100vh - 23rem) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/common/correspondence/expand-email/expand-email.component.scss"],"names":[],"mappings":"AAAA;EACI,sCAAA;AACJ","sourcesContent":[".editorcorrecs > .tox-tinymce {\r\n    height: calc(100vh - 23rem) !important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
